import { View } from 'backbone.marionette';
import './index.styl';
import template from './index.jst';
import Radio from "backbone.radio";
import _ from 'lodash';

const CHANNEL_TRADE = Radio.channel('trade');

export class TradeHistory extends View {
	get template() {
		return template;
	}

	initialize() {
		this.model.set({
			history: {},
			rounds: [],
			players_by_id: {},
			squad_by_id: {},
			reamining_trades: {}
		});

		this.listenTo(CHANNEL_TRADE, 'data:changed', this.update);
		this.listenTo(this.model, 'change', this.render);
	}

	update({ history, actual_round_id, players_by_id, squad_by_id, team }){
		const
			rounds = _.range(actual_round_id, 0),
			remaining_trades = {};

		let trade_limit = team.season_trades_limit;

		_.each(rounds.slice().reverse(), round => {
			trade_limit -=_.size(history[round]);
			remaining_trades[round] = trade_limit;
		});

		this.model.set({
			history,
			players_by_id,
			squad_by_id,
			rounds,
			remaining_trades
		})
	}
}

export default TradeHistory;